import React from 'react';
import Textarea from 'react-textarea-autosize';
import { RCFormGroup } from '../RCFormGroup';
import type { FormattedString, TagType } from '../../types';

interface Props {
  /** ID of the input component, must be unique across the page */
  id: string;

  /** html attr, used by html form submission */
  name: string;

  /** Main label text (or more complex components if you really need to) */
  label: FormattedString;

  disabled?: boolean;

  /** Signals to browser's form validator that a non-empty value must be selected */
  required?: boolean;

  /** Validation error message */
  errorText?: string;
  /** Additional info displayed below label */
  helpText?: FormattedString;
  /** Annotation on the field, e.g. 'required', 'optional' */
  tag?: TagType;

  /** called when value changes; updated value in evt.target.value */
  onChange: React.ChangeEventHandler<HTMLTextAreaElement>;

  /** called when input element loses focus */
  onBlur?: React.FocusEventHandler<HTMLTextAreaElement>;

  /** Current value of the input */
  value: string;

  /** Text that appears when the value is empty */
  placeholder?: string;

  /** Min height of the textarea, in number of rows */
  minRows?: number;

  /** Max height of the textarea, in number of rows */
  maxRows?: number;
}

/**
 * Auto-resizing textarea input
 */
export function RCTextArea(props: Props) {
  return (
    <RCFormGroup
      errorText={props.errorText}
      helpText={props.helpText}
      inputId={props.id}
      label={props.label}
      tag={props.tag}
    >
      <Textarea
        disabled={props.disabled}
        id={props.id}
        name={props.name}
        onBlur={props.onBlur}
        onChange={props.onChange}
        placeholder={props.placeholder}
        required={props.required}
        value={props.value}
        minRows={props.minRows}
        maxRows={props.maxRows}
      />
    </RCFormGroup>
  );
}
